var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEducate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1220.35 823.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        letter-spacing: 0em;\n      }\n\n      .cls-2, .cls-3, .cls-4 {\n        fill: #fff;\n      }\n\n      .cls-5 {\n        fill: #a7b5ba;\n      }\n\n      .cls-6 {\n        fill: #d2f2f8;\n      }\n\n      .cls-7 {\n        letter-spacing: -.03em;\n      }\n\n      .cls-8 {\n        letter-spacing: .02em;\n      }\n\n      .cls-9 {\n        fill: #def5fa;\n      }\n\n      .cls-10 {\n        fill: #0db69b;\n      }\n\n      .cls-11 {\n        fill: #9be2f1;\n      }\n\n      .cls-12 {\n        opacity: .9;\n      }\n\n      .cls-13 {\n        fill: #a9e6f3;\n      }\n\n      .cls-14 {\n        letter-spacing: .03em;\n      }\n\n      .cls-15 {\n        letter-spacing: 0em;\n      }\n\n      .cls-16 {\n        letter-spacing: 0em;\n      }\n\n      .cls-17, .cls-18 {\n        fill: #003153;\n      }\n\n      .cls-3, .cls-19, .cls-20, .cls-21, .cls-22, .cls-4, .cls-23, .cls-24 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-3, .cls-19, .cls-20, .cls-22, .cls-23, .cls-24 {\n        stroke: #898989;\n      }\n\n      .cls-25 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-26 {\n        fill: #a0470c;\n      }\n\n      .cls-19, .cls-20, .cls-21, .cls-22, .cls-23, .cls-24 {\n        fill: none;\n      }\n\n      .cls-27 {\n        fill: #ce8945;\n      }\n\n      .cls-28 {\n        fill: #cbf0f8;\n      }\n\n      .cls-29 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-30 {\n        fill: #974003;\n      }\n\n      .cls-31 {\n        fill: #c5eef7;\n      }\n\n      .cls-32 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-33 {\n        letter-spacing: -.05em;\n      }\n\n      .cls-34 {\n        letter-spacing: 0em;\n      }\n\n      .cls-35 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-36 {\n        fill: #06b6db;\n      }\n\n      .cls-20 {\n        stroke-width: .75px;\n      }\n\n      .cls-20, .cls-21, .cls-22, .cls-4, .cls-23, .cls-24 {\n        stroke-linecap: round;\n      }\n\n      .cls-37 {\n        letter-spacing: -.06em;\n      }\n\n      .cls-38 {\n        letter-spacing: -.05em;\n      }\n\n      .cls-39 {\n        letter-spacing: -.05em;\n      }\n\n      .cls-21 {\n        stroke: #fff;\n      }\n\n      .cls-40 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-41 {\n        letter-spacing: .01em;\n      }\n\n      .cls-42 {\n        fill: #b6eaf5;\n      }\n\n      .cls-43 {\n        letter-spacing: 0em;\n      }\n\n      .cls-44 {\n        fill: #000708;\n      }\n\n      .cls-45 {\n        fill: #7b0e1e;\n      }\n\n      .cls-46 {\n        letter-spacing: 0em;\n      }\n\n      .cls-47 {\n        fill: #963e02;\n      }\n\n      .cls-48 {\n        fill: #0b0500;\n      }\n\n      .cls-49 {\n        letter-spacing: .04em;\n      }\n\n      .cls-50 {\n        letter-spacing: -.03em;\n      }\n\n      .cls-51 {\n        letter-spacing: .03em;\n      }\n\n      .cls-52 {\n        letter-spacing: 0em;\n      }\n\n      .cls-53 {\n        letter-spacing: 0em;\n      }\n\n      .cls-54 {\n        letter-spacing: 0em;\n      }\n\n      .cls-55 {\n        letter-spacing: 0em;\n      }\n\n      .cls-56 {\n        fill: #250c03;\n      }\n\n      .cls-57 {\n        letter-spacing: 0em;\n      }\n\n      .cls-58 {\n        letter-spacing: 0em;\n      }\n\n      .cls-22 {\n        stroke-width: .5px;\n      }\n\n      .cls-59 {\n        fill: #464646;\n      }\n\n      .cls-18 {\n        font-family: Nunito-Regular, Nunito;\n        font-size: 20.07px;\n        font-variation-settings: 'wght' 400;\n      }\n\n      .cls-60 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-61 {\n        letter-spacing: 0em;\n      }\n\n      .cls-62 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-63 {\n        clip-path: url(#clippath-3);\n      }\n\n      .cls-4 {\n        stroke: #f9f9f9;\n      }\n\n      .cls-64 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-65 {\n        letter-spacing: -.06em;\n      }\n\n      .cls-66 {\n        letter-spacing: 0em;\n      }\n\n      .cls-67 {\n        letter-spacing: 0em;\n      }\n\n      .cls-68 {\n        letter-spacing: 0em;\n      }\n\n      .cls-69 {\n        fill: #e3f7fb;\n      }\n\n      .cls-70 {\n        fill: #b3e9f4;\n      }\n\n      .cls-71 {\n        letter-spacing: 0em;\n      }\n\n      .cls-72 {\n        fill: #92dfef;\n      }\n\n      .cls-73 {\n        fill: #f59d62;\n      }\n\n      .cls-74 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-23 {\n        stroke-width: 2px;\n      }\n\n      .cls-75 {\n        letter-spacing: 0em;\n      }\n\n      .cls-76 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-77 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-78 {\n        fill: #a1e3f1;\n      }\n\n      .cls-79 {\n        opacity: .71;\n      }\n\n      .cls-80 {\n        letter-spacing: 0em;\n      }\n\n      .cls-81 {\n        fill: #f69e63;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m1657.55,1060.88c-4.06-7.45-114.36,33.34-213.81,66.81-44.99,3.25-100.32,6.83-133.02,6.56,27.64-16.07,69.63-28.83,83.04-31.66,76.17-16.05,176.05-67.42,159.97-82.96-3.92-3.79-39.4-.19-94.02,9.08,1.15-1.31,1.55-2.58,1.09-3.81-4.01-10.57-13.92-13.29-22.41-13.5,30.75-3.99,100.63-15.38,97.06-36.21-2.7-15.74-202.87,54.72-371.46,117.85-146.64,37.53-300.53,85.29-394.86,134-64.95,33.54-101.61,75.92-120.54,119.22-13.28,14.03-21.03,28.82-24.19,46.7-4.76,26.91-.17,52.85,10.04,77.59,7.83,48.85,28.13,85.73,37.19,92.78,22.85,17.78,205.67,197.03,348.88,208.89,143.21,11.85,219.41-32.71,218.63-38.58-.57-4.28-70.22-47.6-107.84-70.7-1.33-2.98-2.71-6.05-4.15-9.24,0,0-14.6-7.92-35.14-21.51-44.66-48.24-162.55-190.33-68.46-255.52,121.88-84.44,386.73-209.99,390.69-212.17,48.66-26.69,260.4-72.22,243.3-103.62Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "BG-2",
    "data-name": "BG",
    className: "cls-2",
    points: "909.35 610.33 317.35 610.33 439.35 428.33 791.35 428.33 909.35 610.33"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "window-2",
    "data-name": "window",
    className: "cls-3",
    points: "576.85 571.83 405.85 571.83 482.85 435.83 585.85 435.83 576.85 571.83"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "R-2",
    "data-name": "R",
    className: "cls-3",
    points: "781.85 543.83 631.85 543.83 630.85 462.83 721.85 462.83 781.85 543.83"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "create"
  }, /*#__PURE__*/React.createElement("g", {
    id: "paintbrush"
  }, /*#__PURE__*/React.createElement("g", {
    id: "stroke"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m1657.55,1060.88c-4.06-7.45-114.36,33.34-213.81,66.81-44.99,3.25-100.32,6.83-133.02,6.56,27.64-16.07,69.63-28.83,83.04-31.66,76.17-16.05,176.05-67.42,159.97-82.96-3.92-3.79-39.4-.19-94.02,9.08,1.15-1.31,1.55-2.58,1.09-3.81-4.01-10.57-13.92-13.29-22.41-13.5,30.75-3.99,100.63-15.38,97.06-36.21-2.7-15.74-202.87,54.72-371.46,117.85-146.64,37.53-300.53,85.29-394.86,134-64.95,33.54-101.61,75.92-120.54,119.22-13.28,14.03-21.03,28.82-24.19,46.7-4.76,26.91-.17,52.85,10.04,77.59,7.83,48.85,28.13,85.73,37.19,92.78,22.85,17.78,205.67,197.03,348.88,208.89,143.21,11.85,219.41-32.71,218.63-38.58-.57-4.28-70.22-47.6-107.84-70.7-1.33-2.98-2.71-6.05-4.15-9.24,0,0-14.6-7.92-35.14-21.51-44.66-48.24-162.55-190.33-68.46-255.52,121.88-84.44,386.73-209.99,390.69-212.17,48.66-26.69,260.4-72.22,243.3-103.62Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-60"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-18",
    transform: "translate(477.56 1014.86) rotate(-27.34) scale(1.24 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "impo"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-14",
    x: 44.69,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-57",
    x: 52.39,
    y: 0
  }, "t "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-53",
    x: 64.59,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-61",
    x: 73.96,
    y: 0
  }, "v"), /*#__PURE__*/React.createElement("tspan", {
    x: 84.1,
    y: 0
  }, "x"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-15",
    x: 94.63,
    y: 0
  }, "p"), /*#__PURE__*/React.createElement("tspan", {
    x: 106.19,
    y: 0
  }, "y as cp"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 24.08
  }, "impo"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-14",
    x: 44.69,
    y: 24.08
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-57",
    x: 52.39,
    y: 24.08
  }, "t matp"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-54",
    x: 111.13,
    y: 24.08
  }, "lo"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-1",
    x: 128.02,
    y: 24.08
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 135.16,
    y: 24.08
  }, "li"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-62",
    x: 145.76,
    y: 24.08
  }, "b"), /*#__PURE__*/React.createElement("tspan", {
    x: 157.02,
    y: 24.08
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-55",
    x: 161.59,
    y: 24.08
  }, "p"), /*#__PURE__*/React.createElement("tspan", {
    x: 173.15,
    y: 24.08
  }, "yp"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-34",
    x: 195.16,
    y: 24.08
  }, "lo"), /*#__PURE__*/React.createElement("tspan", {
    x: 212.06,
    y: 24.08
  }, "t as p"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-52",
    x: 261.42,
    y: 24.08
  }, "l"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-57",
    x: 267.18,
    y: 24.08
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 48.16
  }, "impo"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-14",
    x: 44.69,
    y: 48.16
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-57",
    x: 52.39,
    y: 48.16
  }, "t num"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-15",
    x: 104.42,
    y: 48.16
  }, "p"), /*#__PURE__*/React.createElement("tspan", {
    x: 115.98,
    y: 48.16
  }, "y as np"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 96.32
  }, "num"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 39.83,
    y: 96.32
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    x: 52.63,
    y: 96.32
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-58",
    x: 63.79,
    y: 96.32
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 70.85,
    y: 96.32
  }, "d = 20"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-54",
    x: 0,
    y: 120.4
  }, "f"), /*#__PURE__*/React.createElement("tspan", {
    x: 6.58,
    y: 120.4
  }, "s = c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-74",
    x: 47.92,
    y: 120.4
  }, "p"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-38",
    x: 59.17,
    y: 120.4
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-37",
    x: 62.71,
    y: 120.4
  }, "V"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-16",
    x: 75.39,
    y: 120.4
  }, "ariab"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-54",
    x: 120.2,
    y: 120.4
  }, "l"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-16",
    x: 126.04,
    y: 120.4
  }, "e((2, 1))"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 144.48
  }, "d = c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-62",
    x: 43.38,
    y: 144.48
  }, "p"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-38",
    x: 54.64,
    y: 144.48
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-65",
    x: 58.17,
    y: 144.48
  }, "V"), /*#__PURE__*/React.createElement("tspan", {
    x: 70.85,
    y: 144.48
  }, "ariab"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-34",
    x: 115.66,
    y: 144.48
  }, "l"), /*#__PURE__*/React.createElement("tspan", {
    x: 121.5,
    y: 144.48
  }, "e((num"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-50",
    x: 184.73,
    y: 144.48
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    x: 197.53,
    y: 144.48
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-75",
    x: 208.69,
    y: 144.48
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-57",
    x: 215.75,
    y: 144.48
  }, "d, 1))"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 168.56
  }, "x"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-50",
    x: 10.53,
    y: 168.56
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    x: 23.34,
    y: 168.56
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-75",
    x: 34.49,
    y: 168.56
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 41.56,
    y: 168.56
  }, "d = "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-49",
    x: 75.65,
    y: 168.56
  }, "["), /*#__PURE__*/React.createElement("tspan", {
    x: 82.77,
    y: 168.56
  }, "]"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 192.64
  }, "y"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 10.31,
    y: 192.64
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    x: 23.12,
    y: 192.64
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-58",
    x: 34.27,
    y: 192.64
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 41.34,
    y: 192.64
  }, "d = "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-49",
    x: 75.43,
    y: 192.64
  }, "["), /*#__PURE__*/React.createElement("tspan", {
    x: 82.55,
    y: 192.64
  }, "]"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-61",
    x: 0,
    y: 216.72
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 9.09,
    y: 216.72
  }, "on"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-54",
    x: 31.64,
    y: 216.72
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    x: 41.2,
    y: 216.72
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-54",
    x: 48.22,
    y: 216.72
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 55.3,
    y: 216.72
  }, "aints = "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-61",
    x: 121.06,
    y: 216.72
  }, "["), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-57",
    x: 127.18,
    y: 216.72
  }, "d &gt;= 0]"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 264.88
  }, "obj"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-77",
    x: 27.59,
    y: 264.88
  }, "F"), /*#__PURE__*/React.createElement("tspan", {
    x: 38.37,
    y: 264.88
  }, "un = c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-74",
    x: 92.71,
    y: 264.88
  }, "p"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-57",
    x: 103.96,
    y: 264.88
  }, ".Minimi"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-61",
    x: 168.23,
    y: 264.88
  }, "z"), /*#__PURE__*/React.createElement("tspan", {
    x: 177.32,
    y: 264.88
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-61",
    x: 188,
    y: 264.88
  }, "("), /*#__PURE__*/React.createElement("tspan", {
    x: 194.16,
    y: 264.88
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-62",
    x: 203.45,
    y: 264.88
  }, "p"), /*#__PURE__*/React.createElement("tspan", {
    x: 214.71,
    y: 264.88
  }, ".max"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-61",
    x: 257.63,
    y: 264.88
  }, "("), /*#__PURE__*/React.createElement("tspan", {
    x: 263.79,
    y: 264.88
  }, "d))"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 337.11
  }, "# c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-75",
    x: 26.51,
    y: 337.11
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 33.57,
    y: 337.11
  }, "ea"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-54",
    x: 54.88,
    y: 337.11
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 61.8,
    y: 337.11
  }, "e 20 "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-54",
    x: 106.91,
    y: 337.11
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 114,
    y: 337.11
  }, "andom"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-77",
    x: 176.06,
    y: 337.11
  }, "l"), /*#__PURE__*/React.createElement("tspan", {
    x: 181.78,
    y: 337.11
  }, "y gene"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-54",
    x: 241.78,
    y: 337.11
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 248.86,
    y: 337.11
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-54",
    x: 259.5,
    y: 337.11
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 266.42,
    y: 337.11
  }, "ed "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-61",
    x: 293.97,
    y: 337.11
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 303.06,
    y: 337.11
  }, "oo"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-75",
    x: 325.37,
    y: 337.11
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-57",
    x: 332.44,
    y: 337.11
  }, "dina"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-54",
    x: 370.82,
    y: 337.11
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 377.75,
    y: 337.11
  }, "es append "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-71",
    x: 476.23,
    y: 337.11
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 483.15,
    y: 337.11
  }, "o "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-1",
    x: 499.49,
    y: 337.11
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 506.63,
    y: 337.11
  }, "he"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 361.19
  }, "# "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-61",
    x: 17.22,
    y: 361.19
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 26.31,
    y: 361.19
  }, "or"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-58",
    x: 44.65,
    y: 361.19
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-16",
    x: 51.71,
    y: 361.19
  }, "ect li"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-54",
    x: 94.47,
    y: 361.19
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    x: 104.02,
    y: 361.19
  }, "ts "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-71",
    x: 125.87,
    y: 361.19
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 132.8,
    y: 361.19
  }, "o be used la"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-54",
    x: 241.72,
    y: 361.19
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 248.64,
    y: 361.19
  }, "er"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-64",
    x: 0,
    y: 385.27
  }, "f"), /*#__PURE__*/React.createElement("tspan", {
    x: 6.4,
    y: 385.27
  }, "or x in "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-34",
    x: 66.86,
    y: 385.27
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 73.94,
    y: 385.27
  }, "ange(num"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 164.6,
    y: 385.27
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    x: 177.4,
    y: 385.27
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-75",
    x: 188.56,
    y: 385.27
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-57",
    x: 195.62,
    y: 385.27
  }, "d):"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 409.35,
    xmlSpace: "preserve"
  }, "    p = n"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-62",
    x: 66.2,
    y: 409.35
  }, "p"), /*#__PURE__*/React.createElement("tspan", {
    x: 77.46,
    y: 409.35
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-34",
    x: 82.03,
    y: 409.35
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 89.11,
    y: 409.35
  }, "andom"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-71",
    x: 151.18,
    y: 409.35
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    x: 155.65,
    y: 409.35
  }, "uni"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-64",
    x: 182.96,
    y: 409.35
  }, "f"), /*#__PURE__*/React.createElement("tspan", {
    x: 189.36,
    y: 409.35
  }, "orm(0, 10, si"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-61",
    x: 301.17,
    y: 409.35
  }, "z"), /*#__PURE__*/React.createElement("tspan", {
    x: 310.26,
    y: 409.35
  }, "e=(2, 1))"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 433.43,
    xmlSpace: "preserve"
  }, "    x"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-50",
    x: 31.24,
    y: 433.43
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    x: 44.05,
    y: 433.43
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-75",
    x: 55.2,
    y: 433.43
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 62.27,
    y: 433.43
  }, "d"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-46",
    x: 73.96,
    y: 433.43
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    x: 78.46,
    y: 433.43
  }, "ap"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-15",
    x: 100.79,
    y: 433.43
  }, "pv"), /*#__PURE__*/React.createElement("tspan", {
    x: 122.54,
    y: 433.43
  }, "end(p[00])"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 457.51,
    xmlSpace: "preserve"
  }, "    y"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-50",
    x: 31.02,
    y: 457.51
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-16",
    x: 43.82,
    y: 457.51
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-58",
    x: 54.98,
    y: 457.51
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 62.04,
    y: 457.51
  }, "d"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-46",
    x: 73.74,
    y: 457.51
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    x: 78.24,
    y: 457.51
  }, "append(p[1][0])"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 481.59,
    xmlSpace: "preserve"
  }, "    # add "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-1",
    x: 77.13,
    y: 481.59
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 84.28,
    y: 481.59
  }, "he l2 norm "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-61",
    x: 186.77,
    y: 481.59
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 195.86,
    y: 481.59
  }, "on"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-54",
    x: 218.42,
    y: 481.59
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    x: 227.97,
    y: 481.59
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-54",
    x: 234.99,
    y: 481.59
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-16",
    x: 242.08,
    y: 481.59
  }, "aints "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-29",
    x: 290.62,
    y: 481.59
  }, "f"), /*#__PURE__*/React.createElement("tspan", {
    x: 297.02,
    y: 481.59
  }, "or each u - w"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 505.67,
    xmlSpace: "preserve"
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-61",
    x: 20.71,
    y: 505.67
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 29.8,
    y: 505.67
  }, "on"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-54",
    x: 52.35,
    y: 505.67
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    x: 61.9,
    y: 505.67
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-54",
    x: 68.93,
    y: 505.67
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 76.01,
    y: 505.67
  }, "aint"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-54",
    x: 109.72,
    y: 505.67
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-80",
    x: 119.27,
    y: 505.67
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    x: 123.77,
    y: 505.67
  }, "append(v"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 529.75,
    xmlSpace: "preserve"
  }, "        d[x] &gt;= c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-62",
    x: 120.01,
    y: 529.75
  }, "p"), /*#__PURE__*/React.createElement("tspan", {
    x: 131.27,
    y: 529.75
  }, ".norm2("), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-54",
    x: 201.16,
    y: 529.75
  }, "f"), /*#__PURE__*/React.createElement("tspan", {
    x: 207.74,
    y: 529.75
  }, "s - "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-43",
    x: 236.26,
    y: 529.75
  }, "p"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-16",
    x: 247.76,
    y: 529.75
  }, ")"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 553.83,
    xmlSpace: "preserve"
  }, "    )"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 601.99
  }, "p"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-58",
    x: 11.7,
    y: 601.99
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 18.76,
    y: 601.99
  }, "ob = c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-62",
    x: 73.3,
    y: 601.99
  }, "p"), /*#__PURE__*/React.createElement("tspan", {
    x: 84.56,
    y: 601.99
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-61",
    x: 89.13,
    y: 601.99
  }, "P"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-75",
    x: 101.64,
    y: 601.99
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 108.7,
    y: 601.99
  }, "ob"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-54",
    x: 131.55,
    y: 601.99
  }, "l"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-16",
    x: 137.39,
    y: 601.99
  }, "em"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-76",
    x: 165.24,
    y: 601.99
  }, "("), /*#__PURE__*/React.createElement("tspan", {
    x: 171.4,
    y: 601.99
  }, "obj"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-32",
    x: 199,
    y: 601.99
  }, "F"), /*#__PURE__*/React.createElement("tspan", {
    x: 209.77,
    y: 601.99
  }, "un, "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-61",
    x: 242.18,
    y: 601.99
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 251.27,
    y: 601.99
  }, "on"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-54",
    x: 273.82,
    y: 601.99
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    x: 283.37,
    y: 601.99
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-54",
    x: 290.4,
    y: 601.99
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 297.48,
    y: 601.99
  }, "aints)"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 626.07
  }, "model = p"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-75",
    x: 90.74,
    y: 626.07
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 97.8,
    y: 626.07
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-62",
    x: 108.96,
    y: 626.07
  }, "b"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-53",
    x: 120.22,
    y: 626.07
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    x: 124.87,
    y: 626.07
  }, "so"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-77",
    x: 145.68,
    y: 626.07
  }, "l"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-55",
    x: 151.4,
    y: 626.07
  }, "v"), /*#__PURE__*/React.createElement("tspan", {
    x: 161.59,
    y: 626.07
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-49",
    x: 172.27,
    y: 626.07
  }, "("), /*#__PURE__*/React.createElement("tspan", {
    x: 179.43,
    y: 626.07
  }, ")"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 650.15
  }, "# prints solu"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-68",
    x: 112.01,
    y: 650.15
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 119.15,
    y: 650.15
  }, "ion"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 674.23
  }, "print("), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-34",
    x: 48.32,
    y: 674.23
  }, "fs"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-33",
    x: 64.45,
    y: 674.23
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-61",
    x: 68.04,
    y: 674.23
  }, "v"), /*#__PURE__*/React.createElement("tspan", {
    x: 78.18,
    y: 674.23
  }, "alu"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-61",
    x: 106.01,
    y: 674.23
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    x: 116.48,
    y: 674.23
  }, ")"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 698.31
  }, "print(mode"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-51",
    x: 99.03,
    y: 698.31
  }, "l"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-16",
    x: 105.59,
    y: 698.31
  }, ")"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 746.47
  }, "# add "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-68",
    x: 56.43,
    y: 746.47
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 63.57,
    y: 746.47
  }, "he an"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-61",
    x: 112.85,
    y: 746.47
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-15",
    x: 122.3,
    y: 746.47
  }, "w"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-16",
    x: 139.04,
    y: 746.47
  }, "er "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-54",
    x: 162.07,
    y: 746.47
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 169,
    y: 746.47
  }, "o "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-68",
    x: 185.33,
    y: 746.47
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-16",
    x: 192.47,
    y: 746.47
  }, "he "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-61",
    x: 219.72,
    y: 746.47
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 228.81,
    y: 746.47
  }, "oo"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-75",
    x: 251.13,
    y: 746.47
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 258.19,
    y: 746.47
  }, "dina"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-54",
    x: 296.58,
    y: 746.47
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 303.5,
    y: 746.47
  }, "e li"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-54",
    x: 329.95,
    y: 746.47
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    x: 339.5,
    y: 746.47
  }, "ts"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 770.55
  }, "x"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-50",
    x: 10.53,
    y: 770.55
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    x: 23.34,
    y: 770.55
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-75",
    x: 34.49,
    y: 770.55
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 41.56,
    y: 770.55
  }, "d"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-46",
    x: 53.26,
    y: 770.55
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    x: 57.75,
    y: 770.55
  }, "append("), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-54",
    x: 131.91,
    y: 770.55
  }, "fs"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-39",
    x: 148.05,
    y: 770.55
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-43",
    x: 151.64,
    y: 770.55
  }, "v"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-16",
    x: 161.77,
    y: 770.55
  }, "alue[0][0])"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 794.63
  }, "y"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 10.31,
    y: 794.63
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    x: 23.12,
    y: 794.63
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-58",
    x: 34.27,
    y: 794.63
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 41.34,
    y: 794.63
  }, "d"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-46",
    x: 53.03,
    y: 794.63
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    x: 57.53,
    y: 794.63
  }, "append("), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-54",
    x: 131.69,
    y: 794.63
  }, "fs"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-39",
    x: 147.83,
    y: 794.63
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-61",
    x: 151.42,
    y: 794.63
  }, "v"), /*#__PURE__*/React.createElement("tspan", {
    x: 161.55,
    y: 794.63
  }, "alue[1][0])"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 842.79
  }, "# g"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-58",
    x: 28.98,
    y: 842.79
  }, "re"), /*#__PURE__*/React.createElement("tspan", {
    x: 46.59,
    y: 842.79
  }, "y "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-64",
    x: 62.08,
    y: 842.79
  }, "f"), /*#__PURE__*/React.createElement("tspan", {
    x: 68.49,
    y: 842.79
  }, "or "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-68",
    x: 92,
    y: 842.79
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 99.15,
    y: 842.79
  }, "he "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-54",
    x: 126.4,
    y: 842.79
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 133.48,
    y: 842.79
  }, "andom"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-77",
    x: 195.54,
    y: 842.79
  }, "l"), /*#__PURE__*/React.createElement("tspan", {
    x: 201.26,
    y: 842.79
  }, "y gene"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-34",
    x: 261.26,
    y: 842.79
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 268.34,
    y: 842.79
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-71",
    x: 278.98,
    y: 842.79
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-16",
    x: 285.9,
    y: 842.79
  }, "ed villages"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 866.87
  }, "c = [&apos;g"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-75",
    x: 54.2,
    y: 866.87
  }, "re"), /*#__PURE__*/React.createElement("tspan", {
    x: 71.82,
    y: 866.87
  }, "y&apos;] * num"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-50",
    x: 152.1,
    y: 866.87
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-16",
    x: 164.9,
    y: 866.87
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-58",
    x: 176.06,
    y: 866.87
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 183.12,
    y: 866.87
  }, "d"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-66",
    x: 0,
    y: 915.03
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-46",
    x: 9.49,
    y: 915.03
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    x: 13.99,
    y: 915.03
  }, "append(&apos;"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-75",
    x: 92.58,
    y: 915.03
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-16",
    x: 99.65,
    y: 915.03
  }, "ed&apos;)"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 939.1
  }, "# g"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-54",
    x: 28.98,
    y: 939.1
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 36.06,
    y: 939.1
  }, "aph"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 963.18
  }, "p"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-67",
    x: 11.7,
    y: 963.18
  }, "l"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-41",
    x: 17.46,
    y: 963.18
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-53",
    x: 24.76,
    y: 963.18
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    x: 29.42,
    y: 963.18
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-46",
    x: 39.07,
    y: 963.18
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 48.28,
    y: 963.18
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-35",
    x: 58.91,
    y: 963.18
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-54",
    x: 65.68,
    y: 963.18
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 72.6,
    y: 963.18
  }, "er(x"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-50",
    x: 107.35,
    y: 963.18
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    x: 120.16,
    y: 963.18
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-75",
    x: 131.31,
    y: 963.18
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-57",
    x: 138.38,
    y: 963.18
  }, "d, y"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-50",
    x: 170.14,
    y: 963.18
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    x: 182.94,
    y: 963.18
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-75",
    x: 194.1,
    y: 963.18
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-57",
    x: 201.16,
    y: 963.18
  }, "d, "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-43",
    x: 222.61,
    y: 963.18
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 231.7,
    y: 963.18
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-34",
    x: 242.86,
    y: 963.18
  }, "l"), /*#__PURE__*/React.createElement("tspan", {
    x: 248.7,
    y: 963.18
  }, "or="), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-66",
    x: 279.08,
    y: 963.18
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-16",
    x: 288.57,
    y: 963.18
  }, ")"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 987.26
  }, "p"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-67",
    x: 11.7,
    y: 987.26
  }, "l"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-41",
    x: 17.46,
    y: 987.26
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-53",
    x: 24.76,
    y: 987.26
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    x: 29.42,
    y: 987.26
  }, "sh"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-55",
    x: 50.47,
    y: 987.26
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    x: 61.48,
    y: 987.26
  }, "w"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-49",
    x: 78.36,
    y: 987.26
  }, "("), /*#__PURE__*/React.createElement("tspan", {
    x: 85.52,
    y: 987.26
  }, ")"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-8",
    x: 0,
    y: 1011.34
  }, "v"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-57",
    x: 10.72,
    y: 1011.34
  }, "v")))))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "educate"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m473.35,62.33c-61.41,35.51-9,142-64,170s-140-46-209,60c-95.33,146.45-115,215-96,273,30.24,92.32,138,0,138,0,0,0,272.54-156.81,370.27-107.91,97.73,48.91,136.23,146.36,241.48,104.13,105.25-42.23,144.78-29.49,174.25-7.23,45,34,105.78,92.43,101,4-4-74,24-97-34-151-62.73-58.4,28-142-95-162-31.7-5.15-145.34-1.06-213-92C694.35,28.33,556.35,14.33,473.35,62.33Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "table"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "1207.35 729.33 28.35 729.33 299.35 387.33 933.35 387.33 1207.35 729.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "edge",
    className: "cls-59",
    points: "426.35 416.33 276.35 641.33 956.3 641.33 807.34 416.33 426.35 416.33"
  })), /*#__PURE__*/React.createElement("g", {
    id: "monitor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "screen"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "BG",
    className: "cls-2",
    points: "909.35 610.33 317.35 610.33 439.35 428.33 791.35 428.33 909.35 610.33"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-40"
  }, /*#__PURE__*/React.createElement("g", {
    id: "screen_bg",
    "data-name": "screen bg",
    className: "cls-79"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m417.01,490.68c-1.54.77-2.95,1.76-4.07,2.8-.4.38-.78.75-1.11,1.13.65-1.84,1.51-3.75,2.54-5.64.2-.34.39-.64.57-.9,1.37-1.9,2.08-1.52,2.16-.45.13,1.05-.38,2.76-.09,3.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m421.41,491.4s-.07.05-.11.08c.13-.61-.13-1.32-.89-1.54-.74-.22-1.65,0-2.48.31.19-.15.4-.31.68-.55,2.16-2.02,4.47-3.5,5.49-3.27.5.11.61.64.17,1.51-.44.87-1.4,2.04-2.87,3.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m479.95,484.56c-.62,16.37-3.99,30.86-7.27,45.39-1.56,1.39-2.92,3.91-4.48,4.38.11.25-2.49,1.53-5.85,2.95l-.17.07-.25.09-.51.18c-.34.12-.69.24-1.06.36-.72.24-1.51.47-2.34.69-1.69.43-3.48.83-5.63,1.08-4.17.49-9.68.46-15.52-1.67.48-.03.96-.08,1.43-.14.44-.08.86-.17,1.28-.26.83-.19,1.66-.4,2.41-.67,1.4-.57,2.79-1.2,3.83-1.99.54-.38,1.08-.77,1.56-1.19.45-.42.88-.85,1.29-1.29.85-.87,1.46-1.82,2.08-2.77,2.31-3.85,3.16-8.09,3.41-12.46-1.35-.41-3.3-.8-4.79-1.65-1.52-.84-2.37-2.09-2.1-3.52.6-2.68,1.07-5.15,1.26-7.43.2-2.28.19-4.38.12-6.32-.05-1.96-.17-3.77-.24-5.52-.02-.88-.09-1.73-.03-2.61.3-.94.61-1.88.92-2.83.72.02,6.11.65,12.5.57,6.37-.11,13.75-.91,18.17-3.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m502.88,477.85c6.33-1.68,16.27-.5,20.26-.58.71,6.77,1.18,13.45.75,19.45,3.25,1.77,5.81,3.77,8.51,4.17-.12,1.2-.24,2.39-.36,3.58-10.23,5.58-20.38,11.37-30.77,16.76-.31-1.95.66-9.85,1.36-18.71.71-8.87,1.1-18.71.25-24.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m485.11,485.76c2.04-1.63,3.84-3.17,5.52-4.72,3.96-1.28,7.97-2.46,12.25-3.19,1.67,11.91,1.58,23.21-.57,32.41.71-.28,2.83,3.34,3.55,3.06-2.5,3.86-5.22,4-4.59,7.91-9.63,5-19.46,9.68-29.64,13.51,1.36-3.43,4.02-2.73,6.23-3.48-2.13-2.94-3.73-2.59-5.16-1.32,3.28-14.53,6.65-29.01,7.27-45.39.67-.21,1.34-.42,2.01-.63,1.18,1.49,2.31,2.99,3.15,1.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m444.92,467.17c3.3-1.55,6.58-2.96,9.72-4.42.8-.37,1.59-.74,2.37-1.1.4-.19.79-.37,1.18-.55l.59-.28c.09-.04.21-.11.27-.12l.15-.02c.8-.12,1.64-.32,2.54-.57,1.79-.5,3.83-1.24,6.13-2.14,2.08-.65,4.29-1.3,6.6-1.93-.8,1.55-2.06,3.82-2.93,5.89-.87,2.08-1.34,3.97-.53,5.02-.92,3.17-2.87,8.22-4.21,12.48-1.34,4.27-2.04,7.87-.38,8.63,1.68.83-1.59-2.29-6.02-4.74-2.22-1.23-4.72-2.26-7.09-2.85-.59-.15-1.18-.27-1.75-.38-.7,0-1.55.15-2.3.26-1.54.25-3.01.59-4.32.96-3.74,1.88-7,3.28-10.03,4.61-3.02,1.32-5.81,2.57-8.54,3.96.66-.67,5.58-3.64,6.53-4.58-.36.24-1.89,1.11-3.36,1.97-1.44.87-2.86,1.72-2.86,1.72,0,0,.32-.64.71-1.43.4-.79.79-1.8.81-2.46,4.46-4.06,4.84-5.28,3.7-4.99-1.13.26-3.61,2.11-4.5,2.98-.3-.22-.63-.39-1-.5.02-.03.04-.07.05-.11,3.02-2.67,6.27-5.19,9.38-7.2,2.44-1.83,9.08-8.13,9.08-8.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m447.26,512.14c.6-2.68,1.07-5.15,1.26-7.43.2-2.28.19-4.38.12-6.32-.05-1.96-.17-3.77-.24-5.52-.02-.88-.09-1.73-.03-2.61.3-.94.61-1.88.92-2.83-.47-.01-1.12-.03-1.84-.06-.28-.16-.52-.35-.6-.57,0,.04-.11-.46.11.62.15.67.29,1.32.4,1.96.11.63.21,1.24.31,1.81.1.53.18,1.04.25,1.52.12.92.23,1.72.31,2.33.07.58.11,1,.13,1.2-.17-1.74-.63-5.01-.14-1.26.08.59.14,1.2.18,1.82.04.64.11,1.13.13,1.72.04.55.02,1.2.05,1.69.02.51.02,1.03,0,1.56-.02,1.95-.32,3.72-.59,4.82-.72,2.51-1.27,2.49-.81,2.18-.46.37.06-.33,2.79-.39,1.38-.04,3.1.11,5.47.54l.2.04h.05s9.78,1.85,9.78,1.85h.01s.05-.05.05-.05l.22-.18.43-.35.43-.36.4-.47c.52-.62,1.04-1.26,1.53-1.91.2-1.12.41-2.24.61-3.35.17-1.08.47-2.24.29-3.04-.14-1.75-.31-3.46-.5-5.1-.02-.25-3.76-1.77-5.62-1.6.58-2.17,1.74-4.2,3.09-6.33-.42-.03-3.05-3.98-6.62-6.53-1.79-1.3-3.82-2.27-5.98-2.6-.54-.08-1.09-.13-1.65-.14-.07,0-.13,0-.21,0l-.29.07c-.2.05-.4.1-.59.15-.4.1-.8.22-1.2.34-1.61.5-3.27,1.16-4.93,1.96-3.74,1.88-7,3.28-10.03,4.61-3.02,1.32-5.81,2.57-8.54,3.96-.06.06-.6.93-1.22,1.93-.63,1-1.35,2.12-1.83,2.82,1.33-.57,4.59-2.47,5.18-2.93-.05.12-1.35,1.11-2.73,2.06-1.39.96-2.86,1.86-3.42,2.25-.64.88-1.61,2.65-1.32,2.77-.04.1.77-.04,2.01-.28,1.24-.24,2.91-.63,4.53-.86-4.94,2.08-8.05,2.88-9.77,3.45-.09.11-.15.16-.23.32l-.07.18-.03.09-.02.04s0,.01-.03.11l-.37,1.87c-1.21.7-2.04,1.33-1.9.09-.02-.48-.03-.87-.04-1.32v-.65s0-.32,0-.32v-.16c0-.06,0-.03,0-.05-.1-.14-.15-.38-.24-.42-.03-.02-.12.2-.2.34,0-.03-.04.17-.07.29-.03.14-.06.28-.09.42-.06.29-.12.59-.19.9-.13.58-.24,1.37-.35,2.14-.11.74-.19,1.69-.25,2.63-.07.9-.07,2.06-.04,3.16,0,.54.05,1.16.11,1.79.06.63.13,1.26.21,1.89.21,1.35.47,2.71.86,4.12.78,2.85,2,5.79,3.58,8.38.77,1.31,1.62,2.52,2.52,3.64.88,1.13,1.81,2.18,2.82,3.15,1.98,1.97,3.97,3.41,5.77,4.57,1.7,1.04,3.27,1.84,4.32,2.3-2.18-1.16-4.31-2.56-6.34-4.35-1-.85-1.94-1.81-2.83-2.82-.89-1-1.71-2.04-2.4-3.1-1.43-2.12-2.56-4.4-3.38-6.74-.82-2.35-1.29-4.72-1.46-6.93.55,2.24,1.41,4.56,2.56,6.77.58,1.1,1.23,2.16,1.92,3.19.71,1.01,1.48,1.98,2.29,2.91,1.65,1.85,3.6,3.6,5.64,4.96.51.35,1.04.7,1.55,1.01.5.29,1.01.58,1.53.85.52.27,1.04.53,1.57.78.52.24.99.43,1.5.63.34.1.66.2,1,.3.48-.04.97-.08,1.41-.15.43-.08.85-.17,1.27-.27.82-.2,1.66-.41,2.38-.68,1.39-.57,2.76-1.21,3.79-1.99.54-.38,1.07-.77,1.54-1.19.45-.42.88-.85,1.28-1.29.84-.87,1.44-1.82,2.06-2.76,2.29-3.84,3.14-8.06,3.39-12.42-1.35-.41-3.3-.8-4.79-1.65-1.52-.84-2.37-2.09-2.1-3.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "m361.79,525.04c-6.56-2.25-11.96,1.56-18.95-2.23-11.97-7.64-18.67-21.49-29.08-32.82,17.68-4.95,33.92-12.22,49.32-20.78.03,7.79-8.13,9.06-5.23,19.75.81,1.2,2.87,1.56,4.3,2.33-1.27,6.13-6.64,11.53-2.57,17.53,2.49,3.67,6.32,6.89,10.09,11.29l-1.36.96c-2.64-.77-4.04,2.05-6.51,3.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m391.87,511.1c-3.17,2.61-6.35,5.22-9.53,7.83-.81-1.11-1.65-2.15-2.48-3.12,3.9-2.79,7.61-5.9,11.11-9.25.22,1.46.51,2.97.9,4.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m362.14,491.29c-1.43-.77-3.48-1.13-4.3-2.33-2.9-10.69,5.26-11.96,5.23-19.75,5.93-3.29,11.86-6.88,17.95-10.54-.39,1.64-.78,3.27-1.13,4.93,1.63-1.06,3.99.44,6.32,1.95,1.17.76,2.34,1.52,3.42,1.97.51.24,1.13.31,1.65.32.54,0,1.04-.14,1.51-.43-.36.96-.72,1.93-1.09,2.92-.29.89-.6,1.76-.92,2.62-.64,1.73-1.35,3.4-2.09,5.04-1.47,3.3-3.05,6.5-4.43,9.82-2.76,6.65-4.82,13.79-3.48,23.04-3.52,3.36-7.21,6.47-11.12,9.25-3.77-4.41-7.6-7.62-10.09-11.29-4.07-6,1.3-11.4,2.57-17.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "m392.78,467.41c-.47.29-.97.42-1.51.43-.52,0-1.14-.07-1.65-.32-1.07-.45-2.24-1.21-3.42-1.97-2.33-1.51-4.69-3.01-6.32-1.95.35-1.65.74-3.29,1.13-4.93l2.76-1.66c1.36-.84,2.72-1.66,4.08-2.44l4.09-2.36c1.36-.8,2.72-1.58,4.1-2.3,2.74-1.47,5.48-3,8.24-4.29,1.38-.67,2.75-1.37,4.13-2.01l4.12-1.82c.73-.12,1.45-.26,2.16-.45,3.59-.79,6.9-1.94,10.08-2.76,3.21-.99,6.26-1.62,9.31-2.11.75-.05,1.53-.07,2.31-.08-1.27,1.3-2.51,2.6-3.74,3.92-2.91,3.29-5.59,6.59-8.04,9.87-2.45,3.34-4.65,6.68-6.59,9.92-1.19-1.54-2.69-2.91-4.5-4.07-1.81-1.07-3.94-2.04-6.36-2.57-2.42-.54-5.14-.88-8.07-.73-1.47.06-3.01.16-4.58.38-1.57.24-3.19.56-4.86.95,2.38-.56,3.9,1.06,5.12,2.87,1.22,1.81,2.15,3.76,3.2,4,2.16,1.09,4.18,2.86,5.81,5.1,1.64,2.23,2.94,5.11,3.81,8.1,1.78,6,1.99,12.74,2.04,16.83-.65.67-1.23,1.34-1.72,1.98-.25.32-.48.63-.69.94-.11.15-.19.31-.28.45.05,0-.34.3-.58.49l-.8.63c-4.26,3.44-8.57,7.08-13,10.82-1.69-1.09-4.3-2.94-4.81-2.59-2.26,2.49-4.59,4.88-6.98,7.17-1.34-9.25.72-16.39,3.48-23.04,1.38-3.33,2.97-6.52,4.43-9.82.74-1.64,1.45-3.31,2.09-5.04.32-.86.63-1.73.92-2.62.37-.99.74-1.96,1.09-2.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m418.03,460.12c1.95-3.25,4.14-6.58,6.59-9.92,2.45-3.28,5.13-6.58,8.04-9.87,1.22-1.33,2.46-2.63,3.74-3.92,1.65.02,3.33.01,4.78.56.69-1.42,1.38-2.82,1.43-4.19l3.96-.37c.59.33.52,1.77.97,2.35.46.59,1.42.32,4.14-2.4l1.31.02c.44,0,.83.08,1.24.12l2.45.29c.63,1.8.41,4.09-.84,6.96.96-1.28,1.92-2.56,2.89-3.85,1.74-1.11,2.53-.87,3.06-.31.54.56.83,1.42,1.61,1.74.53-.62,1.34-1.59,2.1-2.29,1.2,1.55,2.97,3.02,4.71,4.81,1.75,1.78,3.25,3.83,4.19,5.4.94,1.6,1.55,2.79,2.02,3.68.46.9.78,1.52.83,1.91-.11.29-.41.8-.65,1.25l-.74,1.35-1.39,2.59c-2.31.63-4.52,1.28-6.6,1.93-2.3.9-4.33,1.64-6.13,2.14-.9.25-1.74.44-2.54.57l-.15.02c-.06.02-.19.08-.27.12l-.59.28c-.39.18-.78.37-1.18.55-.78.36-1.57.73-2.37,1.1-3.14,1.46-6.42,2.87-9.72,4.42,0,0-6.64,6.3-9.08,8.13-3.11,2.02-6.36,4.53-9.38,7.2,1.77-2.98,1.81-4.38,1.17-4.73-.66-.36-1.97.35-3.29,1.31-1.33.95-2.65,2.28-3.62,3.32-.97,1.05-1.6,1.84-1.66,1.89l-1.28.63c-.47-.04-.7-.72-1.16-1.39-.29-.43-.66-.83-1.15-1.03-.48-.18-1.08-.15-1.74.24-1.29.79-2.86,3.09-3.46,7.59-.22.2-.43.42-.63.63-.05-4.09-.26-10.83-2.04-16.83-.88-2.99-2.17-5.87-3.81-8.1-1.63-2.25-3.66-4.01-5.81-5.1-1.03-.25-3.66-1.49-5.97-2.8-2.28-1.32-4.09-2.78-2.35-4.07,1.68-.79,3.56-1.42,5.49-1.81,1.94-.35,3.93-.51,5.84-.5,1.91,0,3.75.34,5.43.71,1.67.37,3.19.95,4.51,1.6,1.32.65,2.43,1.32,3.36,2.05.93.73,1.66,1.44,2.22,2.04,1.12,1.21,1.59,2.05,1.53,1.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "m553.07,473.7c2.66-.4,5.33-.85,8.05-1.31-2.51,1.31-5.7,1.27-5.51,4.95-1.61-.43-2.89.21-4.17.85.34-1.74.91-3.21,1.62-4.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "m557.9,494.42l-2.08,1.04c-1.28-2.6-1.2-5.88.81-5.28-1.3-2.59-1.37.69-2.02-.6-1.72-3.45-1.02-3.98.12-4.03,2.92,5.8,4.79,12.11,3.75,12.64l-1.38.69c.21-1.55,1.13-2.83.8-4.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m532.4,500.89c-2.7-.39-5.26-2.4-8.51-4.17.44-6.01-.04-12.69-.75-19.45,7.21-.16,14.2-.73,21.29-1.68-.72,1.28-1.31,2.74-1.67,4.48,1.28-.63,2.56-1.25,4.16-.8.02.71.16,1.54.47,2.57.01.02.02.05.04.08-1.13.02-1.83.54-.14,4,.64,1.31.72-1.96,2.01.64-2-.64-2.09,2.64-.83,5.25l2.06-1.01c.33,1.63-.59,2.88-.8,4.45-5.98,2.93-11.83,6.06-17.68,9.22.12-1.19.24-2.38.36-3.58Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m636.01,482.65c-7.92,3.21-15.33,7.61-21.87,12.86.4-1.05.82-2.11,1.25-3.17.45-1.03.92-2.07,1.42-3.11,1.9-3.14,5.16-4.44,8.64-5.08,3.5-.65,7.21-.65,10.56-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m656.22,477.52s-.01.05-.02.07c-.12.02-.23.02-.35.02l-.86.06c-.61.05-1.24.12-1.89.21-1.32.18-2.74.43-4.25.77-1.5.32-3.13.78-4.71,1.2-1.58.48-3.16.96-4.71,1.52.41-.21.8-.43,1.2-.7.65-.54,1.33-1,2.02-1.46.68-.47,1.38-.9,2.1-1.27,1.43-.78,2.91-1.4,4.33-1.76,1.42-.36,2.82-.48,4.13-.27.65.1,1.28.29,1.88.55.27.14.63.29.8.47.12.19.24.39.34.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m634.75,558.01c3.67-8.38,6.98-16.42,9.27-24.3,2.3-7.84,3.57-15.53,3.32-22.81,1.12-1.61,1.46-4.26,2.55-5.02-.21-.21,1.54-1.97,3.25-4.14.89-1.08,1.8-2.32,2.66-3.47.82-1.16,1.61-2.27,2.25-3.16,3.78,5.59,7.57,12.54,11.56,20.48,1.5-.5,3.5-1.58,5.34-2.44,1.87-.82,3.61-1.43,4.8-.57,1.99,1.93,3.56,4,4.74,6.22,1.15,2.19,1.97,4.58,2.39,7.03.89,4.94.35,10.28-.93,15.66-.29.18-1.06.64-2.22,1.23-.58.3-1.25.65-2.01,1.04-.76.37-1.61.77-2.53,1.21-3.68,1.73-8.56,3.71-13.84,5.41-5.29,1.69-10.95,3.12-16.26,4.3-5.32,1.18-10.3,2.15-14.33,3.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m590.81,540.12c-1.42-3.06-2.2-6.75-2.23-10.64-.03-3.9.68-8.03,2.04-11.95,1.31-3.91,3.35-7.62,5.51-10.65,2.12-3.05,4.47-5.46,6.2-7.17,1.61,3.32,3.91,5.63,6.26,7.14.3.19.59.37.88.53l.22.12c.05.04.04.08.06.12l.08.23c.12.31.26.62.41.9.27.56.65,1.09,1.01,1.54,2.62-2.33,4.68-3.23,6.29-4.29.13.4.31.75.54,1.03-1.81,2.54-2.47,5.6-1.43,7.95.52,1.17,1.57,2.05,2.81,2.41,1.24.37,2.58.24,3.75-.06-.16.97-.72,3.23-2.23,6.07-1.48,2.82-4.05,6.22-7.54,8.86-3.45,2.64-7.66,4.36-11.73,5.43-1.06.3-1.98.48-2.99.71-1.02.21-1.98.41-2.87.59-1.9.4-3.57.71-5.03,1.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m625.77,556.2c-5.19,1.11-10.17,1.49-14.93,1.12-2.21-.66-4.38-1.49-6.43-2.54-2.04-1.08-3.98-2.34-5.73-3.82-3.56-2.91-6.16-6.78-7.88-10.84,2.88-.81,5.7-1.7,8.31-2.57,2.62-.88,5.09-1.8,7.45-2.87,2.32-1.03,4.5-2.14,6.54-3.51,2.03-1.34,3.88-2.9,5.45-4.5-.3-.1-.28-1.16-.19-2.26.08-1.09.22-2.14,0-2.26,1.54-.77,2.5-1.08,3.26-1.59.75-.53,1.26-1.27,1.57-3.22.55-.14,1.07-.35,1.57-.55.14-.06.2-.09.41-.16.19-.07.46-.14.69-.21l1.66-.53c2.47-.78,4.85-1.68,7.14-2.68,4.57-2,8.7-4.4,12.27-7.05-.03,1.73-.74,2.55-1.62,3.04-.89.5-1.97.63-2.88,1.09,1.18,1.34,2.16,1.86,2.97,1.88.79-.02,1.43-.51,1.92-1.26.25,7.28-1.01,14.97-3.32,22.81-2.29,7.88-5.59,15.91-9.27,24.3-.55.09-1.2.19-1.85.28-.63.09-1.29.17-1.95.25-.33-.41-.7-.82-1.04-1.19-.37-.37-.76-.7-1.17-.95-.82-.49-1.73-.66-2.96-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m648.69,462.6c1.63-1.99,3.19-4.07,4.79-6.22,1.6-2.14,3.19-4.37,5.1-6.61,3.76-4.47,8.37-9.01,13.58-13.15,1.76.97,4.15,2.62,6.69,4.14,2.55,1.53,5.25,2.95,8.23,3.45,2.01,1.43,4.36,3.52,6.53,6.06,2.18,2.53,4.18,5.49,5.72,8.45,3.19,5.89,4.52,11.6,6.65,12.81,1.05.63.42-.24-1.41-1.8-1.83-1.54-4.87-3.66-8.58-5.19-3.7-1.56-8.01-2.5-12.02-2.49-1.98-.03-3.9.17-5.7.6-.88.19-1.71.41-2.48.66-.77.24-1.47.49-2.12.76-2.19,2.1-4.53,3.76-6.68,5.38-2.15,1.6-4.13,3.17-5.75,4.82-.28-.51,1.72-3.64,1.38-4.34-.11.24-.84,1.19-1.48,2.14-.64.94-1.18,1.85-1.18,1.85,0,0-.77-.27-1.79-.45-.51-.09-1.08-.17-1.63-.19-.28-.03-.53-.01-.81-.04-.42.01-.85,0-1.23.04-.91-2.8-2.47-2.96-3.69-2.23-1.23.72-2.13,2.32-2.09,2.92-1.02.19-2.08.4-3.16.64-.04-.01-.08-.03-.12-.04,1.04-2.11,2.12-4.17,3.3-6.13.57-1.55-.04-5.86-.04-5.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m679.75,512.58c1.99,1.93,3.56,4,4.74,6.22,1.15,2.19,1.97,4.58,2.39,7.03.89,4.94.35,10.28-.93,15.66,1.54-.93,4.22-2.67,6.52-4.42,2.34-1.71,4.28-3.43,4.67-3.73-2.64-.77-5.74-1.26-5.22-3.49,2.52-5.02,4.97-11.32,6.89-14.8.8-1.01,1.74-1.98,2.74-2.99,1.05-1.01,2.11-2.03,3.19-3.07,2.2-2.11,4.42-4.46,6.15-7.1l.19-1.92c.09-.76.19-1.51.24-2.27.11-1.51.18-3.01.22-4.48.02-2.96-.09-5.83-.5-8.59-.01-.19-.98-1.04-2.18-1.76-1.19-.73-2.62-1.33-3.51-1.28.05-3.48.4-6.71.61-10.07-.23-.02-1.51-1.63-3.69-3.6-2.16-1.98-5.29-4.26-8.88-5.72-3.58-1.5-7.59-2.12-11.08-1.74-1.74.17-3.37.58-4.88,1.26-1.48.64-2.74,1.44-3.79,2.35-2.19,2.1-4.53,3.76-6.68,5.38-2.15,1.6-4.13,3.17-5.75,4.82.02.05.91.54,1.78,1.37.89.81,1.68,1.96,1.97,2.8.44-.34,1.11-1.02,1.62-1.7.53-.68.92-1.36.98-1.59.12.12-.16,1.22-.67,2.32-.51,1.12-1.24,2.19-1.51,2.67.07.56.17,1.47.19,2.27.03.79.02,1.47.18,1.58,0,.15.73.05,1.85-.16,1.11-.2,2.6-.54,4.08-.69-2.02,1.21-3.78,2.01-5.23,2.58-.72.28-1.37.51-1.95.7l-.82.25c-.12,0-.27.16-.41.27l-.4.35c-.33.59-.56,1.2-.91,1.78-1.12-.21-1.87-.37-1.77-.61-.15-.49-.23-.93-.3-1.35-.25.49-1.09,1.75-2.04,2.97-.93,1.23-2.04,2.4-2.5,2.88,1.43-.65,3.25-1.15,5.29-1.69-.75,1.26-1.64,2.49-2.52,3.71-.02.06-.03.13-.05.19,3.77,5.58,7.54,12.5,11.52,20.41,1.5-.5,3.5-1.58,5.34-2.44,1.87-.82,3.61-1.43,4.8-.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "m521.18,566.73c-4.12-1.39-8.57-1.38-12.92-1.78-4.34-.41-8.58-1.31-11.85-4.31-5.2-5.73-7.1-12.65-8.55-19.86-1.39-7.22-2.38-14.77-4.24-22.2,4.1,1.01,8.43,1.51,12.82,1.48,4.38-.07,8.84-.63,13.2-1.72,4.35-1.11,8.65-2.68,12.7-4.74,4.03-2.06,8.04-4.66,12.02-7.78.17,2.05-.28,3.73-.99,5.35-.72,1.56-1.68,3.01-2.58,4.5-1.82,2.97-3.31,6.16-2.34,11.73.77,1.22,3.14,1.43,4.74,2.07-1.14,3.41-3.7,6.76-5.71,9.9-.99,1.59-1.85,3.12-2.24,4.72-.41,1.56-.38,3.15.41,4.79,1.91,4,5.87,7.45,9.44,12.06-.79.44-1.59.85-2.41,1.24-3.46-.65-6.81,2.56-11.52,4.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m569.03,542.99c-4.4,4.58-9.32,9.19-14.83,13.54-.86-1.08-1.78-2.05-2.7-2.96,6.47-4.7,11.99-10.08,16.65-15.59.2,1.63.49,3.3.89,5.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m533.2,529.47c-1.6-.63-3.97-.85-4.74-2.07-.97-5.57.52-8.77,2.34-11.73.9-1.49,1.87-2.94,2.58-4.5.7-1.62,1.16-3.3.99-5.35,3.06-2.38,6.1-5.09,9.14-7.93,3.05-2.89,6.12-5.94,9.24-9.13-.19,1.9-.39,3.82-.55,5.73,3.35-3.57,11.43,2.63,14.83-.96-1.17,8.9-4.38,17.15-7.31,25.72-2.91,8.59-5.68,17.4-5.72,28.01-2.75,2.65-5.81,5.17-8.96,7.47-3.18,2.26-6.48,4.39-9.94,6.2-3.57-4.61-7.53-8.06-9.44-12.06-.79-1.63-.82-3.22-.41-4.79.39-1.6,1.25-3.13,2.24-4.72,2.01-3.14,4.57-6.49,5.71-9.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "m567.03,493.53c-3.41,3.59-11.49-2.6-14.83.96.16-1.92.36-3.83.55-5.73,7.27-7.36,14.81-15.41,23.86-23.03.72-.36,1.41-.75,2.09-1.16,3.9-2.39,7.34-4.7,10.79-6.87,3.45-2.16,6.96-4.1,10.9-5.62-2.12,7.75-3.46,15.45-4.37,22.85-12.28-1.17-25.36,1.82-36.34,7.38,3.94-1.98,8.4,3.85,10.84,3.43,2.76.09,5.81.62,8.88,1.54,3.08.93,6.14,2.23,8.9,3.77,5.55,3.13,9.87,7.22,11.12,10.87-4.48,4.81-8.93,10.35-13.64,16.24-4.71,5.9-9.76,12.28-15.56,18.74-2.1-.5-5.44-1.53-6.09-.91-1.46,1.94-3.11,3.84-4.75,5.74-.85.94-1.74,1.87-2.62,2.79l-1.34,1.38-1.42,1.35c.04-10.61,2.81-19.42,5.72-28.01,2.93-8.58,6.14-16.83,7.31-25.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m596.02,474.94c.91-7.4,2.25-15.1,4.37-22.85,2.01-.75,4.13-1.4,6.42-1.84-.56-1.15-1.11-2.29-2.36-3.1,1.42-.75,2.87-1.44,4.32-2.13,1.04-.06,2.42.77,3.57.88,1.16.11,2.07-.55,2.37-3.53l3.15-1.27,3.18-1.19c2.81.83,5.28,2.4,7.29,5.07-.41-1.39-.83-2.77-1.24-4.17.67-1.7,1.78-2.03,2.96-1.98,1.2.06,2.47.48,3.56.21-.19-.76-.47-1.92-.51-2.88,2.82.25,5.71.01,8.77-.37,3.05-.39,6.19-.96,9.25-1.43.77-.12,1.53-.23,2.26-.34.74-.1,1.45-.22,2.35-.3,1.69-.18,3.26-.3,4.67-.38,2.81-.15,4.92-.08,5.89.06,2.03,1.05,3.98,2.13,5.87,3.22-5.22,4.14-9.82,8.68-13.58,13.15-1.9,2.25-3.5,4.47-5.1,6.61-1.6,2.15-3.16,4.22-4.79,6.22,0,0,.62,4.3.04,5.86-1.18,1.96-2.26,4.02-3.3,6.13-5.12-2.53-10.35-.84-13.84,1.57-3.55,2.41-5.47,5.43-5.66,5.55-1.13.59-2.28,1.16-3.38,1.8-3.34,1.32-8.37,1.8-12.85,3.91-4.47,2.06-8.2,5.77-8.16,12.3l-2.11,2.22c-1.25-3.65-5.57-7.74-11.12-10.87-2.76-1.54-5.82-2.84-8.9-3.77-3.07-.92-6.12-1.45-8.88-1.54-1.22.21-4.46.05-7.15-.48-2.67-.54-4.77-1.48-3.69-2.94,4.91-4.18,14.47-6.79,22.47-7.53,8.02-.82,14.28.21,13.87.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "m648.69,492.1c1.19.89,2.32,1.94,3.14,3.3.38.7.73,1.43.86,2.27.2.86.1,1.63-.01,2.32-.08-.36-.04-.75-.14-1.11l-.13-.62c-.06-.21-.15-.41-.22-.61-.12-.42-.37-.76-.56-1.12-.24-.33-.49-.65-.79-.91-1.2-1.06-2.86-1.51-4.98-1.08-.47-1.1-2.23-1.56-3.95-1.74,1.09-.29,2.2-.48,3.31-.57,1.12-.12,2.38-.22,3.49-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "m630.46,501.52c-.37,0-.74.03-1.11.05.66-.73,1.53-1.47,2.35-1.96.81-.49,1.57-.69,1.66-.29.85-.73.57-.76.19-.66-.38.09-.83.28-.45-.09,1.98-1.96,2.87-2.07,3.5-1.76-1.96,1.64-4.12,3.27-5.71,4.49-1.61,1.22-2.65,2.05-2.83,2.06-.17.01-.34.02-.51.04.86-.68,1.79-1.09,2.89-1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m617.52,506.01c-1.61,1.06-3.67,1.96-6.29,4.29-.36-.45-.74-.99-1.01-1.54-.14-.28-.29-.59-.41-.9l-.08-.23s0-.08-.06-.12l-.22-.12c-.29-.17-.59-.34-.88-.53-2.35-1.51-4.64-3.83-6.26-7.14,3.26-3.09,6.93-5.76,10.71-7.63,3.79-1.84,7.44-2.95,10.68-3.54,3.23-.51,6.04-.61,8.53-.51,2.48.14,4.64.5,6.66.91-1.17.39-2.36.95-3.51,1.55-1.16.64-2.29,1.41-3.37,2.28.93-.21,1.8-.41,2.65-.48.42-.04.82-.07,1.18-.06.36.02.69.08.96.17-.65.37-1.27.8-1.9,1.35-.01.01-.02.03-.03.04-.99-.06-2.07.22-3.26,2.07-.23.35.25.11.68-.04.43-.15.81-.22.26.5-.43-.23-1.32.06-2.08.63-.78.55-1.46,1.3-1.82,1.98.56-.12,1.12-.27,1.69-.36-.88.83-2.01,1.38-2.84,2.13-3.87,1.04-7.35,3.46-9.44,6.36-.23-.29-.41-.63-.54-1.03Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m746.09,525.36l-.92,1.53-1.02,1.54-2.07,3.09c-1.44,2.05-2.95,4.07-4.48,5.95-3.05,3.82-6.19,7.27-9.27,10.5.57-2.3,1.13-4.57,1.69-6.85,1.19-3.56,3.86-5.78,6.99-8.07,1.55-1.12,3.26-2.3,4.79-3.56,1.55-1.26,3.13-2.63,4.27-4.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m757.01,504.32s.02.05.04.07c-2.61,5.38-5.38,11.28-8.91,17.49.17-.45.34-.91.46-1.4,1.29-6.93,2.69-12.76,8.41-16.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m804.97,421.59c-7.78,14.92-13.73,28.34-15.23,42.01-.47.57-.87,1.4-1.26,2.11-.39.72-.72,1.38-1.16,1.51.05.12-.27.42-.83.8-.55.39-1.27.95-2.11,1.45-.42.26-.8.58-1.23.86-.41.3-.88.52-1.25.82-.77.59-1.6.99-2.19,1.38-1.89-6.2-3.54-13.63-5.21-22.1-2.38-.6-6.59.14-8.11-2.35-2.31-5-3.2-9.61-3.02-14.12.21-4.39,1.46-8.74,3.19-12.81.95-.15,8.09-.62,15.96-.29,1.97.1,4,.14,6.01.3,1,.05,2.01.11,3.01.16.99.07,1.97.14,2.95.21.96.04,1.92.09,2.85.13.93.06,1.84.09,2.72.1,1.76-.01,3.41-.02,4.91-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m833.94,429.5c2.25,1.28,4.68,3.17,6.91,5.7,2.23,2.5,4.21,5.69,5.39,9,1.2,3.3,1.59,6.6,1.47,9.17-.1,2.6-.59,4.54-.93,5.9-3.3-1.46-6.64-2.51-9.88-3-3.24-.49-6.33-.37-8.96.38-1.08,1.08-2.37,1.79-3.56,2.3-1.17.49-2.25.77-2.94.97-.26,0-.52.01-.79.04l-.39.04c-.1.01-.36.05-.19.03l.83-.14c.3-.05.63-.15.82-.19.22-.05.5-.15.61-.19.13-.04.36-.14.41-.15l.13-.06.07-.03-.21.11s-.06.04-.08.05c-.1.05-.22.13-.3.2-.04.04-.3.21-.43.34l-.55.49c-.24.22-.37.38-.64.66-.27.28-.52.56-.74.86-.27.32-.59.71-.85,1.08l-.19.28-.09.13h-.02s-.06.05-.06.05c-.13.1-.41.12-.85.11-.84-.02-2.2-.09-3.83-.09l-2.79.02c-.94,0-1.89.11-2.81.14.24-.95,1.13-3.09,2.6-5.93,1.46-2.85,3.5-6.24,5.95-9.87,2.4-3.59,5.26-7.24,8.32-10.41,3.02-3.19,6.27-5.84,8.58-7.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m809.98,424.77c.73-.15,1.44-.29,2.14-.43.7-.12,1.39-.24,2.07-.35,1.36-.22,2.69-.51,3.99-.67,4.59,1,10.07,2.54,15.75,6.18-4.62,4.29-8.54,8.75-11.87,13.04-1.67,2.14-3.2,4.22-4.64,6.22-1.43,1.99-2.86,3.91-4.17,5.65.58.11.3,4.26.82,4.36-3.04,2.13-4.62,1.15-5.59,4.94-6.93.53-13.48,2.18-19.09,4.38.26-1.53.84-2.05,1.5-2.22.67-.14,1.42.1,2.09-.03-.63-1.64-1.22-2.45-1.77-2.72-.55-.29-1.05-.03-1.47.5,1.49-13.67,7.45-27.1,15.23-42.01.84.06,1.67.09,2.5.17.61,1.85,1.09,3.7,2.51,3.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m740.03,503.33c-3.27-8.67-10.32-16.3-18.43-24.04.83-.56,2.14-1.34,3.14-2.44.98-1.09,1.6-2.44,1.11-4.21,1.21-2.07,3.63-5.07,5.65-7.99,1.95-2.91,3.61-5.72,2.58-7.56-.5-.92-.37-.19.2,1.53.6,1.72,1.57,4.4,3.02,7.35,1.43,2.95,3.14,6.15,4.97,9.09,1.79,2.94,3.61,5.59,5.08,7.57,4.76,3.11,7.8,7.1,10.3,11.29-.7.57-3.53-1.65-4.39-1.15.45.21,3.33,3.37,3.33,3.37,0,0-.75,1.38-1.68,3.11-.97,1.82-2.13,4-2.9,5.46-2.91-.55-3.79.55-3.92,1.96-.1,1.39.63,3.02,1.12,3.36-.44.89-.97,1.81-1.48,2.73-.03.02-.07.04-.1.06-.46-1.03-.92-2.07-1.39-3.11-.47-1-.95-2-1.42-3.01-.94-1.33-4.78-3.36-4.78-3.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m766.39,448.09c-2.31-5-3.2-9.61-3.02-14.12.21-4.39,1.46-8.74,3.19-12.81-.62.09-1.49.2-2.45.33-.96.15-2.01.38-3.01.58-2,.41-3.79.82-4.12.94,1.84,1.83,4.08,3.7,3.3,5.29-1.34,1.56-2.86,3.15-4.26,4.66-1.39,1.54-2.76,2.81-3.89,3.63-1.65.75-3.8.99-6.05,1.35-2.21.39-4.68.76-6.72,1.57-.86,1.51-1.67,3.02-2.43,4.51-.69,1.51-1.29,3.02-1.84,4.52-.1.21,1.93,3.94,3.36,5.02-1.16,1.53-2.74,2.56-4.4,3.51.34.33.99,5.61,3.29,11.14,2.2,5.58,5.81,11.41,9.98,14.39,4.76,3.11,7.8,7.1,10.3,11.29.03-.03.29-.43.7-1.07.41-.65.95-1.51,1.55-2.39,1.19-1.86,2.6-3.81,3.53-5.08-.95-.45-3.59-.59-4.1-.46.11-.18,1.3-.6,2.61-.92,1.32-.33,2.74-.65,3.37-.94.61-.71,1.57-1.89,2.36-2.97.82-.98,1.45-1.88,1.44-2.14.29-.39-2.55-1.41-4.85-3.18,1.1.13,2.15.29,3.12.43.97.13,1.86.23,2.68.28.76.05,1.52.1,2.28.16.7.03,1.33.02,1.89-.04.41-.29.82-.49,1.22-.73.84.75,1.4,1.26,1.27,1.38,0,.42-.03.77-.11,1.08.74-.37,3.85-1.61,4.77-1.78-.59-.12-1.28-.35-2.02-.6-.71-.24-1.5-.55-2.38-.92.45-.23.88-.48,1.3-.74.45-.23.91-.45,1.35-.69.02-.04.04-.09.07-.12-1.88-6.18-3.53-13.59-5.18-22.03-2.38-.6-6.59.14-8.11-2.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "m644.52,589.33c-2.91-2.62-6.42-4.05-9.68-5.94-3.24-1.84-6.22-4.29-7.43-8.23-.79-3.6-.67-7.14-.12-10.63.57-3.52,1.56-6.99,2.68-10.49,1.13-3.5,2.38-7.02,3.65-10.57,1.27-3.55,2.54-7.14,3.9-10.68.03,1.57.78,3.15,2.18,4.43,1.4,1.29,3.43,2.21,5.76,2.74,2.33.54,4.98.59,7.66.28,2.63-.28,5.56-1.08,8.47-2.22.17,3.59-1.46,5.23-2.86,7.17-1.41,1.96-2.56,4.23-2.35,9.66.44,1.39,2.07,2.38,3.17,3.51-1.09,2.73-3.29,4.89-5.11,7.18-1.8,2.31-3.31,4.72-2.73,8.32.7,4.38,3.06,8.85,5.04,14.33-.71.14-1.41.28-2.12.42-1.29-.82-2.76-.79-4.42-.42-1.68.32-3.57.97-5.7,1.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m686.09,582.57c-2.03,1.35-4.2,2.65-6.43,3.9-1.11.63-2.29,1.23-3.44,1.83-1.19.6-2.45,1.19-3.68,1.76-.54-1.27-1.14-2.46-1.76-3.6,1.42-.56,2.85-1.19,4.19-1.83,1.32-.65,2.63-1.33,3.87-2.07,2.52-1.45,4.84-3.06,7.03-4.75.03,1.52.07,3.1.21,4.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m659.57,558.36c-1.1-1.13-2.73-2.11-3.17-3.51-.21-5.42.94-7.69,2.35-9.66,1.4-1.94,3.02-3.58,2.86-7.17,4.5-1.74,9.1-4.35,13.76-7.51-.1,1.52-.19,3.03-.29,4.55,2.51-1.8,9.06,5.98,11.75,3.96-.71,7.17-3.52,13.14-6.33,19.56-2.83,6.44-5.73,13.29-6.93,22.92-5.07,3.02-10.73,5.36-16.8,6.69-1.98-5.49-4.34-9.95-5.04-14.33-.58-3.6.93-6.01,2.73-8.32,1.82-2.29,4.01-4.45,5.11-7.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "m686.82,539.02c-2.69,2.02-9.23-5.76-11.75-3.96.1-1.51.19-3.03.29-4.55,2.69-1.82,5.41-3.82,8.19-5.94,2.8-2.14,5.56-4.29,8.09-6.37.45-.13.89-.29,1.3-.47,4.61-2.25,7.13-5.34,10.84-7.46,2.18,6.04,3.74,12.49,4.67,18.93-5.05-.95-9.87-1.78-14.54-2.16-4.65-.4-9.26-.22-13.41.38,2.96-.43,6.87,5.69,8.82,6.03,4.41,1.65,10.04,5.07,14.87,8.95,4.84,3.89,8.91,8.22,10.06,11.83l-5.88,5.63c-1.99,1.9-4.03,3.84-6.21,5.81-4.32,3.93-9.06,7.98-14.48,11.85-1.73-1.14-4.27-3.12-4.89-2.79-2.78,2.45-5.86,4.74-9.23,6.75,1.2-9.63,4.1-16.48,6.93-22.92,2.81-6.43,5.61-12.39,6.33-19.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m708.45,529.2c-.93-6.44-2.49-12.9-4.67-18.93.94-.55,1.98-1.04,3.15-1.46-.95-.86-1.9-1.7-3.07-2.3.48-.56.91-1.11,1.36-1.67.57-.07,1.82.44,2.55.42.73,0,.87-.6-.89-2.72.56-.84,1.14-1.58,1.68-2.51,1.98.03,4.4.52,7.37,1.65-1.22-.78-2.44-1.55-3.67-2.33-1.86-2.52,1.18-1.94,1.79-2.93-.67-.39-1.71-1-2.47-1.56,5.77-2.8,6.29-12.46,7.01-13.91,1.08-.49,2.1-1.05,3.02-1.65,8.11,7.74,15.16,15.37,18.43,24.04,0,0,3.84,2.03,4.78,3.36.48,1.01.95,2.01,1.42,3.01.46,1.04.93,2.08,1.39,3.11-5.06,1.9-7.52,6.03-8.96,9.95-.79,1.95-1.27,3.85-1.59,5.3-.36,1.43-.52,2.41-.58,2.52-.83,1.05-1.65,2.14-2.5,3.15-2.74,2.62-7.42,4.44-11.2,6.85-3.8,2.46-6.78,5.65-6.64,11.86l-1.89,1.81c-1.16-3.61-5.23-7.95-10.06-11.83-4.84-3.88-10.46-7.3-14.87-8.95-1.98-.31-10.38-4.27-8.82-6.03,1.81-.96,4.54-1.33,7.57-1.33,3.04,0,6.34.41,9.39.91,6.09,1.02,11.3,2.26,10.98,2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "m827.6,484.39c-2.09,1.4-4.25,2.64-6.46,3.73,1.7-1.76,4.51-2.85,2.61-5.92,1.53-.17,2.25-1.21,2.94-2.24.65,1.55.92,3.03.91,4.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "m812.54,469.76c.22-.37.45-.74.65-1.12,2.55,1.38,4.57,3.72,2.8,3.8,2.46,1.54.52-.84,1.75-.09,3.33,1.96,3.12,2.6,2.32,2.98-2.74-1.75-5.37-3.66-7.3-5.15-1.93-1.49-3.17-2.57-3.03-2.82.13-.22.25-.45.37-.67.94,1.02,1.18,2.01,2.43,3.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m821.43,459.91c.7-.2,1.78-.48,2.94-.97,1.18-.51,2.47-1.22,3.56-2.3,2.63-.75,5.72-.87,8.96-.38,3.25.48,6.59,1.53,9.88,3-1.3,4.94-3.52,8.46-5.77,11.49-2.27,2.95-4.67,5.53-7.23,7.91-.18-1.43-.63-2.9-1.5-4.38-.53,1.18-1.13,2.35-2.64,2.79-.44-.54-1.05-1.1-1.92-1.73-.02-.01-.04-.02-.08-.04.83-.54,1.01-1.28-2.46-2.96-1.29-.65.76,1.71-1.82.38,1.84-.38-.3-2.69-2.95-3.85-.2.47-.44.93-.66,1.39-1.31-.98-1.57-2.08-2.56-3.11.4-.93.75-1.87,1.04-2.83.29-.95.44-1.71.52-2.4.07-.67.04-1.21-.05-1.49l-.08-.16s-.06-.06-.09-.06c-.14.01.29-.01.5-.04l.38-.05.31-.03c.41-.04.89-.14,1.18-.19l-.83.14c-.17.02.1-.01.19-.03l.39-.04c.27-.03.53-.04.79-.04Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "L_screen",
    "data-name": "L screen"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "window",
    className: "cls-2",
    points: "576.85 571.83 405.85 571.83 482.85 435.83 585.85 435.83 576.85 571.83"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Lines"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 484.85,
    y1: 454.83,
    x2: 540.46,
    y2: 454.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 483.8,
    y1: 459.56,
    x2: 539.41,
    y2: 459.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 480.8,
    y1: 464.56,
    x2: 537.85,
    y2: 464.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 477.91,
    y1: 470.56,
    x2: 536.85,
    y2: 470.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 474.91,
    y1: 476.56,
    x2: 535.85,
    y2: 476.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 502.25,
    y1: 493.42,
    x2: 563.85,
    y2: 493.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 499.85,
    y1: 501.83,
    x2: 562.85,
    y2: 501.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 496.25,
    y1: 512.42,
    x2: 562.85,
    y2: 512.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 490.85,
    y1: 524.83,
    x2: 562.85,
    y2: 524.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 487.85,
    y1: 535.83,
    x2: 560.85,
    y2: 535.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 552.51,
    y1: 478.81,
    x2: 565.35,
    y2: 478.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 550.35,
    y1: 482.71,
    x2: 566.39,
    y2: 482.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-23",
    x1: 412.56,
    y1: 559.52,
    x2: 577.35,
    y2: 559.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 421.27,
    y1: 572.56,
    x2: 427.2,
    y2: 559.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 555.15,
    y1: 572.72,
    x2: 556.73,
    y2: 559.26
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "445.85 544.83 448.8 544.92 466.8 506.92 464.85 506.83 445.85 544.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "468.27 544.89 470.84 544.83 476.84 522.83 474.85 522.82 468.27 544.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "456.85 544.83 459.85 544.83 465.85 527.83 463.85 527.83 456.85 544.83"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-23",
    x1: 436.35,
    y1: 545.7,
    x2: 476.35,
    y2: 545.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-23",
    x1: 436.72,
    y1: 544.99,
    x2: 465.65,
    y2: 492.29
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "570.85 474.83 546.85 474.83 552.85 454.83 570.85 454.83 570.85 474.83"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "top",
    className: "cls-36",
    x: 428.35,
    y: 431.03,
    width: 197,
    height: 14.31
  }), /*#__PURE__*/React.createElement("g", {
    id: "X"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 573.39,
    y1: 442.41,
    x2: 581.3,
    y2: 438.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 573.53,
    y1: 438.1,
    x2: 580.85,
    y2: 442.83
  }))), /*#__PURE__*/React.createElement("polygon", {
    id: "window-3",
    "data-name": "window",
    className: "cls-19",
    points: "576.85 571.83 405.85 571.83 482.85 435.83 585.85 435.83 576.85 571.83"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "taskbar",
    className: "cls-17",
    x: 316.85,
    y: 585.33,
    width: 595,
    height: 37.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m343.47,605.33h-8.26c-6.87,0-5.87-1.78-3.87-4.44l5-7.11c2-3.44,3-4.44,6-4.44h8c4,0,5,0,3,4.33l-4,7.23c-2,4.44-3.18,4.44-5.87,4.44Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "R_screen",
    "data-name": "R screen"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "R",
    className: "cls-2",
    points: "781.85 543.83 631.85 543.83 630.85 462.83 721.85 462.83 781.85 543.83"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-63"
  }, /*#__PURE__*/React.createElement("g", {
    id: "header"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "736.35 477.33 630.35 477.33 630.35 458.33 729.35 458.33 736.35 477.33"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 708.35,
    y1: 467.33,
    x2: 720.23,
    y2: 467.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 709.85,
    y1: 470.56,
    x2: 722.35,
    y2: 470.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 710.85,
    y1: 473.56,
    x2: 724.35,
    y2: 473.56
  })), /*#__PURE__*/React.createElement("g", {
    id: "rigth_lines",
    "data-name": "rigth lines"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-19",
    x1: 639.35,
    y1: 520.33,
    x2: 694.68,
    y2: 520.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-19",
    x1: 639.12,
    y1: 525.33,
    x2: 697.35,
    y2: 525.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-23",
    x1: 714.35,
    y1: 522.33,
    x2: 758.35,
    y2: 522.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-23",
    x1: 719.35,
    y1: 534.33,
    x2: 767.35,
    y2: 534.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-19",
    x1: 640.12,
    y1: 536.33,
    x2: 703.35,
    y2: 536.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-19",
    x1: 639.12,
    y1: 530.33,
    x2: 701.35,
    y2: 530.33
  })), /*#__PURE__*/React.createElement("g", {
    id: "grid"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 630.96,
    y1: 483.83,
    x2: 740.85,
    y2: 484.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 624.85,
    y1: 489.83,
    x2: 764.85,
    y2: 489.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 626.85,
    y1: 495.83,
    x2: 766.85,
    y2: 495.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 628.85,
    y1: 503.83,
    x2: 768.85,
    y2: 503.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 628.85,
    y1: 511.83,
    x2: 768.85,
    y2: 511.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-19",
    x1: 646.85,
    y1: 511.83,
    x2: 644.85,
    y2: 483.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-19",
    x1: 669.38,
    y1: 511.94,
    x2: 665.38,
    y2: 483.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-19",
    x1: 692.85,
    y1: 511.83,
    x2: 685.85,
    y2: 483.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-19",
    x1: 715.37,
    y1: 511.63,
    x2: 704.43,
    y2: 484.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-19",
    x1: 722.53,
    y1: 484.27,
    x2: 739.2,
    y2: 511.83
  }))), /*#__PURE__*/React.createElement("polygon", {
    id: "R-3",
    "data-name": "R",
    className: "cls-19",
    points: "781.85 543.83 631.85 543.83 630.85 462.83 721.85 462.83 781.85 543.83"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "people"
  }, /*#__PURE__*/React.createElement("g", {
    id: "R-4",
    "data-name": "R"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "m1009.64,576.08c38.48,6.65,70.08,26.6,99.26,51.28,18.95,16.03,36.08,33.75,50.71,53.84,1.16,1.59,2.1,3.35,3.14,5.02,4.55,7.29,4.62,11.58-2.68,16.24-9.55,6.1-20.01,10.86-30.34,15.61-4.67,2.15-10.04,2.7-14.95,4.41-1.14.4-2.43,2.68-2.31,3.97.95,10.53,2.24,21.03,3.38,31.54,1.15,10.64,2.24,21.28,3.39,32.22-68.48,2.02-136.71,4.04-205.77,6.08-1.98-13.84-3.95-27.62-6.09-42.52-4.54,1.37-8.99,2.53-13.3,4.06-11.45,4.05-22.73,8.61-34.28,12.33-15.15,4.88-32.08-2.57-40.33-17.03-5.34-9.37-8.07-19.45-8.98-30.14-.94-11.06-2.83-22.09-3-33.15-.38-24.46.05-48.93.21-73.4.01-1.75.55-3.49.84-5.23,10.53-.33,21.06-.66,31.6-1,4.23,29.53,8.46,59.05,12.72,88.58.06.44.42.84.64,1.24,3.67-10.73,6.68-21.66,11.07-32,17.05-40.16,41.7-73.22,85.01-88.14,2.34-.81,4.7-1.56,7.04-2.34,17.58-3.8,35.26-4.12,53.02-1.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "m871.35,412.28c.45,17.68,2.17,35.15,8.8,51.77.64,1.6,1.39,3.15,2.04,4.63,3.32-4.29,6.29-8.17,9.3-12.01,5.85-7.48,15-6.98,19.26-4.32,5.7,3.56,8.26,13.22,5.8,20.79-2.38,7.32-7.33,12.59-13.5,16.82-7.23,4.94-7.85,6.39-3.03,13.33,9.17,13.2,20.15,24.56,35.92,29.63,6.24,2,12.99,3.19,19.53,3.3,15.93.27,31.99,1.5,47.63-3.1-.19.44-.25,1.09-.58,1.3-7.4,4.58-5.76,10.39-2.82,16.9,3.66,8.1,6.66,16.49,9.95,24.76-17.76-2.64-35.44-2.31-53.02,1.48-2.55-8.61-5.24-17.18-7.6-25.83-.9-3.29-2.51-4.25-5.9-4.49-22.94-1.64-43.56-9.51-60.41-25.31-11.24-10.53-17.56-24.3-20.04-39.44-1.48-9.07-2.49-18.4-2.12-27.56.57-14.25,2.43-26.54,8.79-39.6.26-.53,1.49-2.65,2-3.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m871.35,412.28c5.39-7.49,9.87-15.91,16.38-22.26,12.39-12.09,27.78-19.32,44.78-23,26.91-5.82,52.61-3.08,74.89,13.82,18.38,13.94,29.53,33.11,32.92,56.27,4.13,28.19-6.09,52.54-20.98,75.4-4.76,7.3-10.81,13.77-16.26,20.62-15.64,4.59-31.7,3.37-47.63,3.1-6.54-.11-13.29-1.3-19.53-3.3-15.76-5.06-26.75-16.42-35.92-29.63-4.82-6.94-4.2-8.39,3.03-13.33,6.18-4.22,11.13-9.5,13.5-16.82,2.46-7.57-.1-17.23-5.8-20.79-4.26-2.66-13.4-3.16-19.26,4.32-3.01,3.84-5.98,7.72-9.3,12.01-.65-1.48-1.4-3.03-2.04-4.63-6.64-16.63-8.35-34.09-8.8-51.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "m840.14,610.22c-10.53.33-21.07.67-31.6,1-4.02-5.17-8.15-10.26-12.05-15.51-10.52-14.18-11.7-29.41-5.44-45.73,3.83-9.98,8.21-19.39,16.17-26.87,5.36-5.03,12.17-5.2,16.07,1.02,3.01,4.8,5.05,10.39,6.59,15.89,3.01,10.79,5.53,21.52,10.68,31.79,5.62,11.2,3.15,23.63.2,35.51-.24.96-.41,1.94-.62,2.91Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "L"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m395.24,644.51c-18.26,30.42-36.01,61.16-54.96,91.15-14.16,22.41-30.24,43.52-49.63,61.88-9.95,9.42-21.45,15.24-35.05,16.72-3.28.36-6.63.04-9.95-.01-17.23-.3-34.46-.32-51.67-1.03-9.61-.4-19.16-2.05-28.76-2.92-8.8-.8-17.64-1.09-26.42-2.03-10.01-1.08-19.95-2.74-29.95-3.94-7.11-.85-14.29-1.17-21.39-2.08-8.35-1.08-16.64-2.64-24.98-3.83-8.54-1.21-17.11-2.17-25.66-3.33-6.38-.87-12.73-1.9-19.72-2.96,1.18-9.41,1.85-18.33,3.49-27.07,2.25-12.03,4.96-23.99,7.95-35.86,9.2-36.57,21.2-72.08,43.33-103.15,14.48-20.33,32.27-36.78,57.48-42.92,10.86-2.65,21.86-3.88,33.06-1.92,2.14.37,4.48-.46,6.73-.73.94.56,1.82,1.49,2.81,1.63,19.98,2.83,37.71,10.71,53.31,23.45,24.27,22.47,34.41,52.09,42.1,82.99,1.78,7.15,3.75,14.3,6.24,21.22,1.79,4.97,5.34,6.24,9.88,3.56,5.26-3.11,10.43-6.59,14.94-10.69,8.12-7.38,16.08-15.01,23.43-23.15,9.1-10.07,17.57-20.72,26.19-31.22,4-4.87,7.72-9.96,11.56-14.95,1.29.17,2.65.15,3.86.55,10.61,3.5,21.2,7.08,31.79,10.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "m187.18,553.14c20.22,2.98,39.31-.88,57.6-9.53.45-.21.9-.43,1.34-.67,11.65-6.28,11.56-6.21,3.79-16.57-6.55-8.74-12.34-17.85-11.66-29.5.42-7.07,5.79-14.21,12.59-16.56,5.62-1.94,11.31.13,16.34,6.59,2.74,3.52,4.86,7.53,7.11,11.42,1.22,2.11,2.12,4.4,3.55,7.46,7.91-15.57,15.57-30.32,22.88-45.24,2.06-4.22,4.02-6.8,9.3-5.3,10.3,2.92,19.51.89,27.05-7.11,4.94,15.43,8.39,31.21,8.8,47.4.55,21.61-3.76,41.9-20.13,57.63-17.86,17.16-39.12,27.86-63.75,30.9-7.39.91-15.06-.56-22.61-.61-1.15,0-2.71,1.48-3.4,2.68-3.7,6.41-7.18,12.94-10.74,19.43-15.6-12.75-33.33-20.63-53.31-23.45-.99-.14-1.88-1.07-2.81-1.63,6.02-9.11,12.04-18.22,18.06-27.33Zm139.52-45.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "m310.02,455.23c-5.28-1.5-7.24,1.08-9.3,5.3-7.3,14.92-14.97,29.67-22.88,45.24-1.44-3.06-2.33-5.35-3.55-7.46-2.25-3.88-4.37-7.9-7.11-11.42-5.03-6.46-10.72-8.53-16.34-6.59-6.79,2.35-12.17,9.49-12.59,16.56-.68,11.65,5.11,20.76,11.66,29.5,7.76,10.36,7.86,10.29-3.79,16.57-.44.24-.89.46-1.34.67-18.29,8.65-37.38,12.51-57.6,9.53-12.32-2.77-22.8-8.8-31.45-17.95-9.27-9.82-14.93-21.29-17.26-34.76-2.76-15.97.48-30.76,6.73-45.23,1.83-4.24,3.77-8.44,5.48-12.26-6.04-.91-12.48-1.42-18.7-2.89-16.84-4-27.99-14.78-33.24-30.97-5.57-17.16-2.01-32.88,8.98-47.37,12.3-16.23,29.03-22.68,48.4-22.15,22.75.62,41.57,13.72,47.61,37.2,1.05,4.09,1.27,8.4,1.87,12.53,6.82-1.97,13.45-4.31,20.27-5.78,20.28-4.35,39.8-.84,59.37,5.18,20.16,6.21,33.63,19.32,43.18,37.33,0,0,7.79,14.15,8.86,22.73,1.07,8.58-22.58,11.38-27.25,6.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "m333.43,486.38c1.43,4.91-.1,11.36-3.61,15.35-1.48,1.68-4.29.92-4.71-1.28-.86-4.53.51-10.63,3.46-14.91,1.3-1.89,4.22-1.36,4.86.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m395.24,644.51c-10.59-3.56-21.18-7.13-31.79-10.64-1.21-.4-2.57-.38-3.86-.55.58-18.25,6.3-39.7,28.11-47.88,9.33-3.5,19.08-5.87,28.66-8.69,6.76-1.99,7.17-2.63,13.98-4.42,2.06-.54,8-1,10,0,3.24.96,3.82,5.15,3,9-2,8-3.89,11.36-9.3,18.03-12.5,15.4-25.82,30.14-38.8,45.15Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "M"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m680.8,449.07l11.49,19.84,62.65-80.4s-.13-112.06-29.24-145.15c-22.97-26.11-140.59-45.82-173.34,16.71-22.97,43.86-20.88,134.7-20.88,134.7l117.86,2.56-4-18-70.01-23.19,3.13-37.59,10.44,65.79h121.13c1.04,0,1.04-60.56,1.04-60.56l9.4,60.56-39.68,64.74Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-44",
    points: "635.13 494.83 635.13 485.3 671.87 419.71 682.31 415.99 680.23 425.39 635.13 494.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m643.48,378.4c1.04,0,15.66-15.66,36.55-12.53,20.88,3.13,29.24,16.71,29.24,16.71,0,0,6.27,10.44,1.04,11.49-4.58.92-60.56,11.49-62.65,2.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m718.99,127.72c-2.8-1.84-5.62-.12-7.68,1.93-.91-37.52-29.98-67.64-65.74-67.64s-65.77,31.07-65.79,69.41c-1.11-.23-2.23-.1-3.31.57-5.82,3.58-4.88,14.24.22,19.93,2.53,2.82,5.92,5.3,8.71,7.1,8.3,19.04,25.06,32.67,45.44,37.14l-1.99,31.88s4.18,5.57,17.75,5.92c13.57.35,17.75-6.96,17.75-6.96l-1.96-31.33c21.14-5.36,38.11-20.71,45.26-41.65,2.83-1.55,7.38-4.33,10.56-7.67,4.93-5.18,6.1-15.12.76-18.63Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-44",
    cx: 621.47,
    cy: 144.29,
    rx: 5.28,
    ry: 10.44,
    transform: "translate(-13.13 210.04) rotate(-18.99)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-44",
    cx: 673.82,
    cy: 144.38,
    rx: 10.44,
    ry: 5.27,
    transform: "translate(360.75 758.27) rotate(-75.07)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "m699.87,87.07c-3.48-6.08-10.44-12.53-15.66-16.71-12.53-8.35-26.11-9.4-34.46-9.4-3.13,0-7.81.92-10.44,1.15-.36-11.97-5.39-54.96-59.39-46.74-62.6,9.53-73.27,75.71-74.21,87.16s-.69,85.15-13.63,99.4c-11.52,12.68-40.7.91-40.79,1.95-.09,1.04,12.66,10.96,33.48,12.67,28.1,2.31,60.78-38.8,63.7-61.61,2.93-22.88.04-59.17,8.35-74.14,5.22-9.4,25.14-26.5,55.24-22.98,13.68,1.6,17.98,3.97,19.17,5.69-4.52,1.19-10.72,2.67-14.89,4.76-7.34,3.15-14.15,9.18-21.93,18.8-17.75,21.93-14.62,53.26-14.62,53.26,0,0,13.57,2.86,24.02-16.71,1.05-1.96,2.29-4.47,3.66-7.33,4.1,7.94,8.87,14.05,8.87,14.05,0,1.33,65.75,0,65.75,0,0,0,2.37-7.04,4.6-15.25.56,1.18,1.13,2.3,1.7,3.32,9.4,16.71,22.97,18.8,22.97,18.8,0,0,1.04-28.19-11.49-50.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m698.83,471.34c0,12.98-16.26,21.93-29.24,21.93s-22.97-6.86-22.97-19.84,18.35-26.11,31.33-26.11,20.88,11.04,20.88,24.02Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducate);
export default __webpack_public_path__ + "static/media/educate.56cc4b7428920f7c30d2801ddf5975af.svg";
export { ForwardRef as ReactComponent };